import React from 'react';
import MuiTooltip from "../MuiComponents/MuiTooltip";
import InfoIcon from "@mui/icons-material/Info";

const Info = ({ tooltip = null, iconColor = 'var(--grey1)', children }) => {
    return (
        <MuiTooltip
            title={tooltip}
            componentsProps={{
                tooltip: {
                    sx: {
                        maxHeight: 300,
                        overflowY: 'hidden',
                        padding: '0px',
                    },
                },
            }}
        >
            {/* If children provided, use them, otherwise fallback to InfoIcon */}
            {children || (
                <InfoIcon
                    style={{
                        height: 20,
                        color: iconColor,
                    }}
                />
            )}
        </MuiTooltip>
    );
};

export default Info;
